import React, { useEffect, useState } from "react";
import { InputGroup, Table, Badge, Spinner, ListGroup } from "react-bootstrap";
import SplitPane from "react-split-pane";
import Pagination from "../../Pagination";
import UseToggle from "../../../Hooks/UseToggle";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";
import AssignRandomizationSubject from "../../EDCManagement/FormManagement/FormList/SubjectData/AssignRandomizationSubject";
import { eiwrsRandomizationSchemaServices } from "../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";
import Discontinue from "../../EDCManagement/FormManagement/FormList/Discontinue";
import Swal from "sweetalert2";
import SubjectDetail from "../SubjectScreening/SubjectDetail";
import ReplaceRandomization from "./ReplaceRandomization";
import DispenseSubjectKit from "./DispenseSubjectKit";
import ReassignRandomizationSubject from "../../EDCManagement/FormManagement/FormList/SubjectData/ReassignRandomizationSubject";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { isHTMLIdentifier } from "../../../utils/universalFunction";
import { FaLock } from "react-icons/fa";
import TableProperties from "./TableProperties";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";

const Randomization = ({ onMouseDown, tableRef, screenType }) => {
  const [subjectColumns, setsubjectColumns] = useState([]);
  const [schemaList, setSchemaList] = useState([]);
  const [schemaLoader, setSchemaLoader] = useState(false);
  const [subjectList, setSubjectList] = useState([]);
  const [subjectListCount, setSubjectListCount] = useState(0);
  const [viewMode, setViewMode] = useState(screenType === "edc" ? "randomized" : "screened");
  const [subjectData, setSubjectData] = useState("");
  const [schemaData, setSchemaData] = useState("");
  const [loading, setLoading] = useState(false);
  const [subjectLoader, setSubjectLoader] = useState(false);
  const [subjectStatusLoader, setSubjectStatusLoader] = useState("");
  const [randomizerLoader, setRandomizerLoader] = useState("");
  const [reason, setReason] = useState("");
  const [category, setCategory] = useState("");
  const [remark, setRemark] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const [tableColumns, setTableColumns] = useState({});
  const [tablePropertiesLoader, setTablePropertiesLoader] = useState(false);
  const toggles = UseToggle();
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();
  const eiwrsPermission = JSON.parse(localStorage.getItem("studyPermissionData"));
  const tablePropertyType = "studySubjectRandomization";

  const getStudySubjectColumnData = async () => {
    setLoading(true);
    let data = await studySubjectManagementServices.getStudySubjectColumnData(
      "active",
      studyId,
      subjectData?.siteId,
    );
    setsubjectColumns(data?.data || []);
    setLoading(false);
  };

  useEffect(() => {
    if (subjectData?.siteId) {
      getStudySubjectColumnData();
    }
  }, [subjectData?.siteId]);

  const getEIWRSRandomizationSchemaData = async (e) => {
    setSchemaLoader(true)
    let data = await eiwrsRandomizationSchemaServices.getEIWRSRandomizationSchemaData(
      "active",
      studyId,
      StudyMode,
    );
    setSchemaList(data?.data || []);
    setSchemaLoader(false)
  };

  const getTablePropertiesData = async () => {
    const data = await studyOtherSettingsServices.getTablePropertiesData(
      tablePropertyType,
      studyId
    );
    setTableColumns(data?.data || {});
  };

  const updateTableProperties = async () => {
    setTablePropertiesLoader(true);
    const data = await studyOtherSettingsServices.updateTableProperties({
      studyId,
      type: tablePropertyType,
      columns: tableColumns,
    });
    if (data?.statusCode === 200) {
      toggles.setToggle6();
      getTablePropertiesData();
    }
    setTablePropertiesLoader(false);
  };

  useEffect(() => {
    getEIWRSRandomizationSchemaData();
    getTablePropertiesData();
  }, []);

  const visibleColumn = (columnName) => !tableColumns[columnName];
  const tablePropertyColumns = [
    { columnName: "SITEID", columnLabel: "Site Id" },
    { columnName: "SCREENID", columnLabel: "Screen Id" },
    ...(viewMode !== "screened" ? [
      { columnName: "RANDOMNUMBER", columnLabel: "Random No." },
      { columnName: "SUBJECTID", columnLabel: "Subject Id" },
      ...(schemaData?.randomizationType === "assignBased" ? [
        { columnName: "EVENTID", columnLabel: "Event Id" },
        { columnName: "FORM", columnLabel: "Form" },
        { columnName: "FIELD", columnLabel: "Field" },
      ] : []),
      ...(schemaData?.randomizationType === "stratified" ? [
        ...new Set(subjectList.flatMap((item) => Object.keys(item?.stratification || {}))),
      ].map((columnName) => ({ columnName, columnLabel: columnName })) : []),
      ...(schemaData?.randomizationType === "block" || schemaData?.randomizationType === "stratified" ? [
        { columnName: "BLOCKNUMBER", columnLabel: "Block Number" },
        { columnName: "BLOCKPOSITION", columnLabel: "Block Position" },
      ] : []),
      { columnName: "KITNUMBER", columnLabel: schemaData?.randomizationType === "assignBased" ? "Kit Number" : "Total Kit" },
      ...(screenType === "eiwrs" ? [{ columnName: "TREATMENT", columnLabel: "Treatment" }] : []),
    ] : []),
    { columnName: "SCREENINGDATE", columnLabel: "Screening Date" },
    ...(screenType === "eiwrs" ? [
      { columnName: "SCREENSTATUS", columnLabel: "Screen Status" },
      { columnName: "SUBJECTSTATUS", columnLabel: "Subject Status" },
    ] : []),
    { columnName: "VIEW", columnLabel: "View" },
    ...(screenType === "eiwrs" ? [{ columnName: "ACTION", columnLabel: "Action" }] : []),
  ];

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(subjectListCount / itemsPerPage);

  const getStudySiteSubjectRandomizationData = async () => {
    setSubjectLoader(true)
    let data
    if (schemaData?.randomizationType == "assignBased") {
      data = await studySiteDataEntryServices.getStudySiteSubjectEventFormFieldRandomizationData(viewMode, studyId, schemaData?.schemaId, LoginCat, StudyMode, pageNumber, itemsPerPage)
    } else {
      data = await studySubjectManagementServices.getStudySiteSubjectRandomizationData(viewMode, studyId, schemaData?.schemaId || "no", LoginCat, StudyMode, pageNumber, itemsPerPage)
    }
    setSubjectList(data?.data || [])
    setSubjectListCount(data?.count || 0)
    setSubjectLoader(false)
  }

  const subjectRandomization = async (siteId, subjectId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Subject Randomization!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Randomized it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setRandomizerLoader(subjectId)
        let userData = {}
        userData.schemaId = schemaData?.schemaId
        userData.studyId = studyId
        userData.siteId = siteId
        userData.subjectId = subjectId
        userData.mode = StudyMode
        let data = await eiwrsRandomizationSchemaServices.subjectRandomization(userData)
        if (data?.statusCode === 200) {
          getStudySiteSubjectRandomizationData()
        }
        setRandomizerLoader("")
      }
    });
  };

  const randomizationStudySiteSubjectEventFormField = async (siteId, subjectId, schemaId, checkId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Subject Event Randomization!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Randomized it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setRandomizerLoader(subjectId)
        let userData = {}
        userData.schemaId = schemaId
        userData.checkId = checkId
        userData.studyId = studyId
        userData.siteId = siteId
        userData.subjectId = subjectId
        userData.mode = StudyMode
        let data = await studySiteDataEntryServices.randomizationStudySiteSubjectEventFormField(userData)
        if (data?.statusCode === 200) {
          getStudySiteSubjectRandomizationData()
        }
        setRandomizerLoader("")
      }
    });
  };

  useEffect(() => {
    if (viewMode === "screened") {
      getStudySiteSubjectRandomizationData();
    } else {
      if (schemaData?.schemaId) {
        getStudySiteSubjectRandomizationData();
      }
    }
  }, [schemaData?.schemaId, viewMode, pageNumber, itemsPerPage]);

  const updateStudySubjectStatus = async (subjectId, siteId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Subject Status ${status}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSubjectStatusLoader(subjectId)
        let userData = {};
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.studyId = studyId;
        userData.mode = StudyMode;
        userData.subjectStatus = status;
        if (reason) {
          userData.reason = reason;
        }
        if (remark) {
          userData.remark = remark;
        }
        if (category) {
          userData.category = category;
        }
        if (completionDate) {
          userData.completionDate = completionDate;
        }
        let data = await studySubjectManagementServices.updateStudySubjectRowData(userData);
        if (data?.statusCode === 200) {
          setSubjectStatusLoader("")
          setReason("")
          setRemark("")
          setCategory("")
          setCompletionDate("")
          if (status === "discontinue") {
            toggles.setToggle2()
          }
          if (status === "complete") {
            toggles.setToggle3()
          }
          getStudySiteSubjectRandomizationData();
        }
      }
    });
  };

  const stratificationColumns = [
    ...new Set(
      subjectList.flatMap(item => Object.keys(item?.stratification || {}))
    )
  ];

  return (
    <>
      {screenType === "eiwrs" &&
        <div
          className="justify-content-between toolbar border-bottom hstack p-1"
          style={{ height: 36 }}
        >
          <InputGroup>
            <button
              className={
                viewMode === "screened"
                  ? "activee updateProfile px-3"
                  : "updateProfile px-3"
              }
              onClick={() => { setViewMode("screened"); setSchemaData(""); setSubjectList([]); setSubjectData("") }}
            >
              Pending
            </button>
            <button
              className={
                viewMode === "randomized"
                  ? "activee updateProfile px-3"
                  : "updateProfile px-3"
              }
              onClick={() => { setViewMode("randomized"); setSchemaData(""); setSubjectList([]); setSubjectData("") }}
            >
              Randomized
            </button>
            <button
              className={
                viewMode === "replacement"
                  ? "activee updateProfile px-3"
                  : "updateProfile px-3"
              }
              onClick={() => { setViewMode("replacement"); setSchemaData(""); setSubjectList([]); setSubjectData("") }}
            >
              Replacement
            </button>
          </InputGroup>
          <button
            title="Table Properties"
            className="updateProfile px-2 text-nowrap"
            onClick={() => toggles.setToggle6()}
          >
            Table Properties
          </button>
        </div>
      }
      {viewMode === "screened" && (
        <div
          className="p-2 border-bottom"
          style={{ backgroundColor: "#f8f9fa" }}
        >
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="d-flex align-items-center gap-2">
              <span className="badge bg-primary bg-opacity-10 text-primary">
                {subjectListCount > 0 ? `${subjectListCount} active` : "No active"}
              </span>
              <span className="text-muted small">
                randomization schema(s) configured. The system selects the
                applicable schema per subject by site, cohort and country rules.
              </span>
            </div>
            <div className="d-flex align-items-center gap-2">
              <span className="badge bg-warning bg-opacity-10 text-warning">
                🔒
              </span>
              <span className="text-muted small">
                Double-blind study. Treatment arm is assigned from the schema's
                list and is not revealed to site users.
              </span>
            </div>
          </div>
        </div>
      )}
      {viewMode === "replacement" && (
        <div
          className="p-2 border-bottom"
          style={{ backgroundColor: "#f8f9fa" }}
        >
          <div className="d-flex align-items-center gap-2">
            <span className="badge bg-warning bg-opacity-10 text-warning">
              ↻
            </span>
            <span className="text-muted small">
              Replacement randomizes a new subject linked to a withdrawn/discontinued subject, without altering the original assignment or block integrity. Replacement uses schemas flagged for replacement where configured.
            </span>
          </div>
        </div>
      )}

      <SplitPane
        split="vertical"
        minSize={20}
        style={{ height: viewMode === "randomized" ? "calc(100vh - 182px)" : "calc(100vh - 218px)" }}
        className="position-relative"
        defaultSize={viewMode === "screened" ? "100%" : "15%"}
      >
        {viewMode !== "screened" &&
          <div className="p-2">
            <ListGroup>
              {schemaLoader ? (
                <PageLoader />
              ) : schemaList?.length === 0 ? (
                <NoDataFoundTable MSG={`Schema not found!`} />
              ) :
                schemaList?.map((schema, index) => (
                  (viewMode === "replacement" ? (schema?.randomizationType != "assignBased") : true) &&
                  <ListGroup.Item
                    action
                    title={schema?.schemaName}
                    onClick={() => {
                      setSchemaData(schema);
                    }}
                    key={index}
                    style={{ padding: "7px 0px 7px 10px" }}
                    className={`hstack ${schemaData?.schemaId === schema?.schemaId ? "selectedMenu" : "bg-white"
                      }`}
                  >
                    <span>{schema?.schemaName}</span>
                  </ListGroup.Item>
                ))}
            </ListGroup>
          </div>
        }
        {subjectLoader ? (
          <PageLoader />
        ) : (subjectListCount === 0 || subjectList?.length === 0) ? (
          <NoDataFoundTable MSG={`Data not found!`} />
        ) : (
          <>
            <Table ref={tableRef} className={`${screenType === "eiwrs" ? "w-auto" : "w-100"} m-0 custom-table`} hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>

                  <th style={{ display: visibleColumn("SITEID") ? undefined : "none" }}>SiteId</th>
                  <th style={{ display: visibleColumn("SCREENID") ? undefined : "none" }}>ScreenId</th>
                  {viewMode !== "screened" && (
                    <>
                      <th style={{ display: visibleColumn("RANDOMNUMBER") ? undefined : "none" }}>Random No.</th>
                      <th style={{ display: visibleColumn("SUBJECTID") ? undefined : "none" }}>Subject Id</th>
                      {schemaData?.randomizationType == "assignBased" &&
                        <>
                          <th style={{ display: visibleColumn("EVENTID") ? undefined : "none" }}>Event Id</th>
                          <th style={{ display: visibleColumn("FORM") ? undefined : "none" }}>Form</th>
                          <th style={{ display: visibleColumn("FIELD") ? undefined : "none" }}>Field</th>
                        </>
                      }
                      {schemaData?.randomizationType === "stratified" &&
                        stratificationColumns.map((column, index) => (
                          <th
                            key={column}
                            style={{ display: visibleColumn(column) ? undefined : "none" }}
                          >
                            {column}
                          </th>
                        ))}
                      {(schemaData?.randomizationType === "block" ||
                        schemaData?.randomizationType === "stratified") && (
                          <>
                            <th style={{ display: visibleColumn("BLOCKNUMBER") ? undefined : "none" }}>
                              Block Number
                            </th>
                            <th style={{ display: visibleColumn("BLOCKPOSITION") ? undefined : "none" }}>
                              Block Position
                            </th>
                          </>
                        )}
                    </>
                  )}
                  {viewMode !== "screened" &&
                    <>
                      <th style={{ display: visibleColumn("KITNUMBER") ? undefined : "none" }}>
                        {schemaData?.randomizationType == "assignBased" ? "Kit Number" : "Total Kit"}
                      </th>
                      {screenType === "eiwrs" &&
                        <th className="text-center" style={{ display: visibleColumn("TREATMENT") ? undefined : "none" }}>
                          Treatment
                        </th>
                      }
                    </>
                  }
                  <th style={{ display: visibleColumn("SCREENINGDATE") ? undefined : "none" }}>
                    Screening Date
                  </th>
                  {screenType === "eiwrs" &&
                    <>
                      <th style={{ display: visibleColumn("SCREENSTATUS") ? undefined : "none" }}>
                        Screen Status
                      </th>
                      <th style={{ display: visibleColumn("SUBJECTSTATUS") ? undefined : "none" }}>
                        Subject Status
                      </th>
                    </>
                  }
                  <th className="text-center" style={{ display: visibleColumn("VIEW") ? undefined : "none" }}>
                    View
                  </th>
                  {screenType === "eiwrs" && (eiwrsPermission?.liveGenerateRandomization ||
                    eiwrsPermission?.qcGenerateRandomization ||
                    StudyMode === "DBP Mode") && (
                      <th
                        className="text-center"
                        style={{
                          width: 300,
                          display: visibleColumn("ACTION") ? undefined : "none",
                        }}
                      >
                        Action
                      </th>
                    )}
                </tr>
              </thead>
              <tbody>
                {subjectList?.map((row, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1 + startIndex}.</td>
                    <td style={{ display: visibleColumn("SITEID") ? undefined : "none" }}>{row?.siteName}</td>
                    <td style={{ display: visibleColumn("SCREENID") ? undefined : "none" }}>{row?.row?.SCREENID}</td>
                    {viewMode != "screened" &&
                      <>
                        <td style={{ display: visibleColumn("RANDOMNUMBER") ? undefined : "none" }}>{row?.row?.RANDOMNUMBER}</td>
                        <td style={{ display: visibleColumn("SUBJECTID") ? undefined : "none" }}>{row?.row?.SUBJECTID || "_"}</td>
                        {schemaData?.randomizationType == "assignBased" &&
                          <>
                            <td style={{ display: visibleColumn("EVENTID") ? undefined : "none" }}>{row?.eventName} {row?.timePointId ? `(${row?.timePointId})` : ""}</td>
                            <td style={{ display: visibleColumn("FORM") ? undefined : "none" }}>{row?.formName} (v{row?.formVersion})</td>
                            <td style={{ display: visibleColumn("FIELD") ? undefined : "none" }}>
                              {isHTMLIdentifier(row?.fieldName || "") ? (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: row?.fieldName,
                                  }}
                                />
                              ) : (
                                row?.fieldName
                              )} ({row?.fieldCode})
                            </td>
                          </>
                        }
                        {schemaData?.randomizationType === "stratified" &&
                          stratificationColumns.map((column) => (
                            <td key={column} style={{ display: visibleColumn(column) ? undefined : "none" }}>
                              {row?.stratification?.[column] || "_"}
                            </td>
                          ))}
                        {(schemaData?.randomizationType === "block" || schemaData?.randomizationType === "stratified") &&
                          <>
                            <td style={{ display: visibleColumn("BLOCKNUMBER") ? undefined : "none" }}>{row?.blockNumber}</td>
                            <td style={{ display: visibleColumn("BLOCKPOSITION") ? undefined : "none" }}>{row?.blockPosition}</td>
                          </>
                        }
                      </>
                    }
                    {viewMode !== "screened" &&
                      <>
                        {schemaData?.randomizationType == "assignBased" ?
                          <td style={{ display: visibleColumn("KITNUMBER") ? undefined : "none" }}>{row?.kitNumber || "_"}</td>
                          :
                          <td style={{ display: visibleColumn("KITNUMBER") ? undefined : "none" }}>{row?.totalKit || 0}</td>
                        }
                        {screenType === "eiwrs" &&
                          <td className="text-center" style={{ display: visibleColumn("TREATMENT") ? undefined : "none" }}>
                            {row?.subjectRandomized ?
                              (eiwrsPermission?.liveTreatmentUnblinded || eiwrsPermission?.qcTreatmentUnblinded || eiwrsPermission?.dbpTreatmentUnblinded) ?
                                row?.treatmentNameData :
                                (row?.treatmentName ? row?.treatmentName : <Badge className="bg-danger hstack gap-1"><FaLock /> Blinded</Badge>)
                              : "_"}
                          </td>
                        }
                      </>
                    }
                    <td style={{ display: visibleColumn("SCREENINGDATE") ? undefined : "none" }}>{row?.row?.SCREENINGDATE || "_"}</td>
                    {screenType === "eiwrs" &&
                      <>
                        <td style={{ display: visibleColumn("SCREENSTATUS") ? undefined : "none" }} className={`fw-bold ${row?.screenStatus === "Pending" ? "text-secondary" : row?.screenStatus === "Failed" ? "text-danger" : "text-success"}`}>{row?.screenStatus}</td>
                        <td style={{ display: visibleColumn("SUBJECTSTATUS") ? undefined : "none" }} className={`fw-bold text-capitalize ${row?.subjectStatus === "discontinue" ? "text-danger" : row?.subjectStatus === "ongoing" ? "text-warning" : "text-success"}`}>{row?.subjectStatus}</td>
                      </>
                    }
                    <td className="text-center" style={{ display: visibleColumn("VIEW") ? undefined : "none" }}>
                      <button
                        onClick={(e) => {
                          toggles.setToggle();
                          setSubjectData(row);
                          e.stopPropagation();
                        }}
                        className="updateProfile"
                        style={{ padding: "1px 10px" }}
                      >
                        View
                      </button>
                    </td>
                    {screenType === "eiwrs" && (eiwrsPermission?.liveGenerateRandomization || eiwrsPermission?.qcGenerateRandomization || StudyMode === "DBP Mode") &&
                      <td style={{ display: visibleColumn("ACTION") ? undefined : "none" }}>
                        <div className="hstack gap-3 justify-content-center">
                          {viewMode === "screened" &&
                            <>
                              <button
                                onClick={(e) => {
                                  toggles.setToggle1();
                                  setSubjectData(row);
                                  e.stopPropagation();
                                }}
                                disabled={row?.subjectStatus === "discontinue"}
                                className="updateProfile"
                                style={{ padding: "1px 10px" }}
                              >
                                Assign Random Number
                              </button>
                              {row?.subjectStatus === "discontinue" ?
                                <button
                                  disabled={subjectStatusLoader}
                                  onClick={() => updateStudySubjectStatus(row?.subjectId, row?.siteId, "ongoing")}
                                  className="updateProfile"
                                  style={{ padding: "1px 10px" }}
                                >
                                  {subjectStatusLoader === row?.subjectId ? (
                                    <div className="hstack gap-2">
                                      <Spinner size="sm" /> Ongoing...
                                    </div>
                                  ) : (
                                    "Ongoing"
                                  )}
                                </button>
                                :
                                <button
                                  onClick={(e) => {
                                    toggles.setToggle2();
                                    setSubjectData(row);
                                    e.stopPropagation();
                                  }}
                                  className="removeProfile"
                                  style={{ padding: "1px 10px" }}
                                >
                                  Discontinue
                                </button>
                              }
                            </>
                          }
                          {viewMode === "randomized" &&
                            <>
                              {row?.subjectRandomized ?
                                <button
                                  onClick={(e) => {
                                    toggles.setToggle3();
                                    setSubjectData(row);
                                    e.stopPropagation();
                                  }}
                                  disabled={row?.kitNumber || row?.subjectStatus === "discontinue"}
                                  className="removeProfile"
                                  style={{ padding: "1px 10px" }}
                                >
                                  Dispense Kit
                                </button>
                                :
                                <button
                                  disabled={randomizerLoader || row?.subjectStatus === "discontinue"}
                                  onClick={() => {
                                    if (schemaData?.randomizationType == "assignBased") {
                                      randomizationStudySiteSubjectEventFormField(row?.siteId, row?.subjectId, row?.eventSchema, row?.schemaId)
                                    } else {
                                      subjectRandomization(row?.siteId, row?.subjectId)
                                    }
                                  }}
                                  className="updateProfile"
                                  style={{ padding: "1px 10px" }}
                                >
                                  {randomizerLoader === row?.subjectId ? (
                                    <div className="hstack gap-2">
                                      <Spinner size="sm" /> randomizing...
                                    </div>
                                  ) : (
                                    "Randomize Now"
                                  )}
                                </button>
                              }
                              {row?.subjectStatus === "discontinue" ?
                                <button
                                  disabled={subjectStatusLoader}
                                  onClick={() => updateStudySubjectStatus(row?.subjectId, row?.siteId, "ongoing")}
                                  className="updateProfile"
                                  style={{ padding: "1px 10px" }}
                                >
                                  {subjectStatusLoader === row?.subjectId ? (
                                    <div className="hstack gap-2">
                                      <Spinner size="sm" /> Ongoing...
                                    </div>
                                  ) : (
                                    "Ongoing"
                                  )}
                                </button>
                                :
                                <button
                                  onClick={(e) => {
                                    toggles.setToggle2();
                                    setSubjectData(row);
                                    e.stopPropagation();
                                  }}
                                  className="removeProfile"
                                  style={{ padding: "1px 10px" }}
                                >
                                  Discontinue
                                </button>
                              }
                              <button
                                onClick={(e) => {
                                  toggles.setToggle5();
                                  setSubjectData(row);
                                  e.stopPropagation();
                                }}
                                disabled={row?.subjectStatus === "discontinue"}
                                className="updateProfile"
                                style={{ padding: "1px 10px" }}
                              >
                                Re-assign Randomization Schema
                              </button>
                            </>
                          }
                          {viewMode === "replacement" &&
                            <>
                              <button
                                onClick={(e) => {
                                  toggles.setToggle4();
                                  setSubjectData(row);
                                  e.stopPropagation();
                                }}
                                disabled={row?.replaced}
                                className="updateProfile"
                                style={{ padding: "1px 10px" }}
                              >
                                Replacement
                              </button>
                              {row?.subjectStatus === "discontinue" ?
                                <button
                                  disabled={subjectStatusLoader}
                                  onClick={() => updateStudySubjectStatus(row?.subjectId, row?.siteId, "ongoing")}
                                  className="updateProfile"
                                  style={{ padding: "1px 10px" }}
                                >
                                  {subjectStatusLoader === row?.subjectId ? (
                                    <div className="hstack gap-2">
                                      <Spinner size="sm" /> Ongoing...
                                    </div>
                                  ) : (
                                    "Ongoing"
                                  )}
                                </button>
                                :
                                <button
                                  onClick={(e) => {
                                    toggles.setToggle2();
                                    setSubjectData(row);
                                    e.stopPropagation();
                                  }}
                                  className="removeProfile"
                                  style={{ padding: "1px 10px" }}
                                >
                                  Discontinue
                                </button>
                              }
                            </>
                          }
                        </div>
                      </td>
                    }
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={subjectListCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>

      <SubjectDetail
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        Show={!toggles?.toggle}
        Hide={toggles?.setToggle}
        subjectColumns={subjectColumns}
        subjectData={subjectData}
        screenType={screenType}
        loading={loading}
        randomizationType={schemaData?.randomizationType}
        Title={`View ${subjectData?.row?.SCREENID} ${subjectData?.subjectVoid ? "(VOID)" : ""} Subject  for Site ${subjectData?.siteName}`}
      />

      <AssignRandomizationSubject
        Show={!toggles?.toggle1}
        Hide={toggles?.setToggle1}
        getStudySiteSubjectList={getStudySiteSubjectRandomizationData}
        subjectSettings={"IWRS"}
        subjectId={subjectData?.subjectId}
        siteId={subjectData?.siteId}
        schemaId={subjectData?.eventSchema}
        Title={`Assign ${subjectData?.row?.SCREENID} ${subjectData?.subjectVoid ? "(VOID)" : ""} Subject for Site ${subjectData?.siteName}`}
      />
      <ReassignRandomizationSubject
        Show={!toggles?.toggle5}
        Hide={toggles?.setToggle5}
        getStudySiteSubjectList={getStudySiteSubjectRandomizationData}
        subjectSettings={"IWRS"}
        subjectId={subjectData?.subjectId}
        siteId={subjectData?.siteId}
        schemaId={subjectData?.eventSchema}
        Title={`Re-assign ${subjectData?.row?.SCREENID} ${subjectData?.subjectVoid ? "(VOID)" : ""}`}
      />

      <Discontinue
        Show={!toggles?.toggle2}
        Hide={toggles?.setToggle2}
        Title={`Discontinue ${subjectData?.row?.SUBJECTID || subjectData?.row?.SCREENID} ${subjectData?.subjectVoid ? "(VOID)" : ""} Subject for Site ${subjectData?.siteName}`}
        subjectStatusLoader={subjectStatusLoader}
        reason={reason}
        setReason={setReason}
        category={category}
        setCategory={setCategory}
        remark={remark}
        setRemark={setRemark}
        updateStudySubjectStatus={() => updateStudySubjectStatus(subjectData?.subjectId, subjectData?.siteId, "discontinue")}
      />

      <DispenseSubjectKit
        Show={!toggles?.toggle3}
        Hide={toggles?.setToggle3}
        subjectData={subjectData}
        randomizationType={schemaData?.randomizationType}
        Title={`Dispence Kit ${subjectData?.row?.SUBJECTID || subjectData?.row?.SCREENID} ${subjectData?.subjectVoid ? "(VOID)" : ""} Subject for Site ${subjectData?.siteName}`}
        getStudySiteSubjectRandomizationData={getStudySiteSubjectRandomizationData}
      />

      <ReplaceRandomization
        Show={!toggles?.toggle4}
        Hide={toggles?.setToggle4}
        subjectData={subjectData}
        Title={`Replace ${subjectData?.row?.SUBJECTID || subjectData?.row?.SCREENID} ${subjectData?.subjectVoid ? "(VOID)" : ""} Subject for Site ${subjectData?.siteName}`}
        getStudySiteSubjectRandomizationData={getStudySiteSubjectRandomizationData}
      />
      <TableProperties
        Show={!toggles?.toggle6}
        Hide={toggles?.setToggle6}
        Title="Randomization Table Properties"
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        columns={tablePropertyColumns}
        tableColumns={tableColumns}
        buttonLoader={tablePropertiesLoader}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
    </>
  );
};

export default Randomization;
